import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
    sendHoverSoundCommand,
    sendSelectClickSoundCommand,
} from 'react-wot-bootstrap'

import styles from './NextSliderButton.scss'

export default class NextSliderButton extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        currentSlide: PropTypes.number,
        slideCount: PropTypes.number,
        style: PropTypes.object,
        onClick: PropTypes.func,
    }

    render() {
        const isDisabled = this.props.currentSlide === this.props.slideCount - 1
        const classNameBase = classNames(this.props.className, styles.next, {
            [styles.isDisabled]: isDisabled,
        })
        return (
            <div
                className={classNameBase}
                style={this.props.style}
                onClick={this.props.onClick}
                onMouseDown={isDisabled ? null : sendSelectClickSoundCommand}
                onMouseEnter={isDisabled ? null : sendHoverSoundCommand}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./containers/Landing/components/NextSliderButton/NextSliderButton.jsx